<template>
    <div>
        <b-overlay :show="is_load" >
            <div v-if="is_data_loaded">
            <info_field f_uniq="cid1" f_type="station_id" :is_disabled="false" 	@update_categ="change_atr" :f_title="__t('STATION_ID')"  :f_val="rest_params.station_id.toString()"></info_field>
            <info_field f_uniq="cid2" f_type="table_id"  :is_disabled="false" 	 	@update_categ="change_atr" :f_title="__t('TABLE_ID')"  :f_val="rest_params.table_id.toString()"></info_field>
            <info_field f_uniq="cid02" f_type="url"  :is_disabled="false" 	 	@update_categ="change_atr" :f_title="__t('URL')"  :f_val="rest_params.url.toString()"></info_field>
            <info_field f_uniq="cid03" f_type="discount_id"  :is_disabled="false" 	@update_categ="change_atr" :f_title="__t('DISCOUNT_ID')"  :f_val="rest_params.discount_id.toString()"></info_field>


            <info_field f_uniq="ci3" 	@update_categ="change_atr" :f_title="__t('AUTHOR_ID')"  :f_val="rest_params.author_id.toString()"></info_field>
            <info_field f_uniq="cid4" 	@update_categ="change_atr" :f_title="__t('WAITER_ID')"  :f_val="rest_params.waiter_id.toString()"></info_field>
            <info_field f_uniq="cid5" 	@update_categ="change_atr" :f_title="__t('CREATOR_ID')"  :f_val="rest_params.creator_id.toString()"></info_field>
            </div>
        </b-overlay>
    </div>
</template>


<script >
import Info_field from "../../../../../sys/info_field.vue";

export default {
    name: "rest_evrasia",
    props: {
        "rest": {
            type: Object,
        }
    },
    components: {Info_field},
    data() {
        return {
            is_load: false,
            is_data_loaded : false,
            rest_params : {
                "url"  : "",
                "author_id" : "",
                "creator_id" : "",
                "waiter_id" : "",
                "station_id" : "",
                "table_id" : "",
                "discount_id" : ""

            }
        }
    },

    beforeDestroy() {
        EventBus.$off('save_rest_action',this.save_params);
    },

    created() {
        this.get_params();
        EventBus.$on('save_rest_action',this.save_params);
    },
    methods: {

        async save_params() {
            this.is_load = true;
            await pos_api.put('/evrasia/restaurants/' + parseInt(this.rest.id) + "/settings",this.rest_params).then(({data}) => {
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    delay_time: 9000,
                    position: "b-toaster-top-left",
                    title: this.__t("ERR_DEL_POS")
                })
            });
        },


        async get_params() {
            this.is_load = true;
            this.is_data_loaded = false;
            await pos_api.get('/evrasia/restaurants/' + parseInt(this.rest.id) + "/settings").then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                   // this.rest_params = {...this.rest_params,...data.data};
                    this.updateParams(data);
                    this.is_data_loaded = true;
                }


            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    delay_time: 9000,
                    position: "b-toaster-top-left",
                    title: this.__t("ERR_DEL_POS")
                })
            });
        },

        updateParams(data) {
            for (const key in data.data) {
                if (data.data.hasOwnProperty(key)) {
                    if (this.rest_params.hasOwnProperty(key)) {
                        this.rest_params[key] = data.data[key];
                    } else {
                        this.$set(this.rest_params, key, data.data[key]);
                    }
                }
            }
        },

        change_atr(param,val) {
            console.log(val);

            this.rest_params[param] = val;
        }
    }
}

</script>


<style scoped>

</style>
